const COLOR_1 = '01';
const COLOR_2 = '02';
const COLOR_3 = '03';
const COLOR_4 = '04';

function token(code, number) {
  return {
    id: number,
    label: code,
    color: `status-${number}`,
    contrast: `constant-${[COLOR_1, COLOR_3].includes(number) ? 'light' : 'dark'}`,
  };
}

function identify(name) {
  switch (name) {
    case 'checagem':
    case 'check':
      return token('Checagem', COLOR_1);
    case 'simulação':
    case 'simulacao':
    case 'simulate':
      return token('Simulação', COLOR_1);
    case 'análise':
    case 'analise':
    case 'analyze':
      return token('Análise', COLOR_1);
    case 'pendente':
    case 'hang':
      return token('Pendente', COLOR_2);
    case 'pré_aprovada':
    case 'pré-aprovada':
    case 'pre_aprovada':
    case 'pre-aprovada':
    case 'preapprove':
      return token('Pré-aprovada', COLOR_2);
    case 'recusada':
    case 'refuse':
      return token('Recusada', COLOR_3);
    case 'restrição':
    case 'restricao':
    case 'restrict':
      return token('Restrição', COLOR_3);
    case 'desistência':
    case 'desistencia':
    case 'dismiss':
      return token('Desistência', COLOR_3);
    case 'aprovada':
    case 'approve':
      return token('Aprovada', COLOR_4);
    case 'formalizada':
    case 'formalize':
      return token('Formalizada', COLOR_4);
    case 'faturada':
    case 'invoice':
      return token('Faturada', COLOR_4);
    case 'pago':
    case 'pay':
      return token('Pago', COLOR_4);
    case 'expirada':
    case 'expire':
      return token('Expirada', COLOR_3);
    case 'cancelada':
    case 'cancel':
      return token('Cancelada', COLOR_3);
    case 'válido':
    case 'valido':
      return token('Válido', COLOR_4);
    default:
      return {};
  }
}

export function id(name) {
  return identify(name).id;
}

export function color(name) {
  return identify(name).color;
}

export function contrast(name) {
  return identify(name).contrast;
}

export default function status(name) {
  return identify(name).label;
}
